export default {
    'gb': {
        'helpBlock': {
            'itemsNotFound': 'Items not found',
            'clear': 'Clear',
            'howCanWeHelpYou': 'How can we help you?',
            'topSuggestions': 'Top suggestions',
            'help': 'Help',
        },
        'publicForm': {
            'firstAndLastName': "First and last name",
            'numberOfGuests': "Number of guests",
            'submit': "Submit",
            'sendingData': "Sending data...",
            'couldNotSend': "Could not send data. Please try again...",
            'formSentSuccessfully': "Form sent succesfully!"
        },
        'flyOutBlock': {
            'expandText': 'View full description',
            'collapseText': 'Close full description',
            'saveChanges': 'Save changes',
            'feedback': 'Feedback',
            'focusAreas': 'Focus Areas',
            'personalNotes': 'Personal Notes',
            'startDate': 'Start date:',
            'dueDate': 'Due date:',
            'progress': 'Progress:',
            'noData': 'No Data',
            'description': 'Description'
        },
        'notesPopup': {
            'notice': 'You are about to close “Personal Notes” witout saving, are you sure you want to exit?',
            'labelCancel': 'continue typing',
            'labelConfirm': 'exit'
        }
    },
    'sv': {
        'helpBlock': {
            'itemsNotFound': 'Objekt hittades inte',
            'clear': 'Rensa',
            'howCanWeHelpYou': 'Hur kan vi hjälpa dig?',
            'topSuggestions': 'Toppförslag',
            'help': 'Hjälp'
        },
        'publicForm': {
            'firstAndLastName': "För-och efternamn",
            'numberOfGuests': "Antal gäster",
            'submit': "Skicka in",
            'sendingData': "Skickar data ...",
            'couldNotSend': "Det gick inte att skicka data. Var god försök igen...",
            'formSentSuccessfully': "Formuläret skickas framgångsrikt!"
        },
        'flyOutBlock': {
            'expandText': 'Se hela beskrivningen',
            'collapseText': 'Stäng fullständig beskrivning',
            'saveChanges': 'Spara ändringar',
            'feedback': 'Respons',
            'focusAreas': 'Fokusområden',
            'personalNotes': 'Personliga anteckningar',
            'startDate': 'Start datum:',
            'dueDate': 'Förfallodatum:',
            'progress': 'Framsteg:',
            'noData': 'Inga data',
            'description': 'Beskrivning'
        },
        'notesPopup': {
            'notice': 'Du håller på att stänga “Personliga anteckningar” utan att spara. Är du säker på att du vill avsluta?',
            'labelCancel': 'fortsätt skriva',
            'labelConfirm': 'utgång'
        }
    }
};



// WEBPACK FOOTER //
// ./src/frontend/config/translations.js